import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseComponent } from '../../component-base';

export interface AttachmentData {
  file: File;
  fileName: string;
}

@Component({
  selector: 'app-attachment-input',
  templateUrl: './attachment.component.html'
})
export class AttachmentComponent extends BaseComponent {
  @Input() acceptedFileTypes: string = '*/*';
  @Input() showDescription: boolean = true;
  @Input() descriptionOptions: string[] = [];
  @Output() submitAttachment = new EventEmitter<AttachmentData>();

  fileName: string = '';
  selectedFile: File | null = null;
  isSubmitted: boolean = false;
  uniqueId: string = 'uploadFile_' + Math.random().toString(36).substr(2, 9);
  @ViewChild('fileInput', { static: false }) fileInputRef!: ElementRef;

  get isValid(): boolean {
    if (this.showDescription) {
      return this.fileName?.trim().length > 0 && !!this.selectedFile;
    }
    else
      return true;
  }

  onFileSelected(event: Event): void {
    this.isSubmitted = true;
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.selectedFile = input.files[0];

      // Validate file size
      if (this.selectedFile.size / 1024 > 8000) {
        this.toastrService.error(this.translate.instant("validation.invalidFileSize", { maxSize: "8 MB" }), "");
        this.reset();
        return;
      }

      // Validate file extension
      const fileExtension = '.' + this.selectedFile.name.split('.').pop()?.toLowerCase();
      const allowedTypes = this.acceptedFileTypes.toLowerCase().split(',').map(t => t.trim());

      if (!allowedTypes.includes('*/*') && !allowedTypes.includes(fileExtension)) {
        this.toastrService.error(this.translate.instant("validation.invalidFileType"), "");
        this.reset();
        return;
      }
    }
  }


  onAdd() {
    this.isSubmitted = true;

    if (this.isValid && this.selectedFile) {
      this.isSubmitted = true;
      this.submitAttachment.emit({
        file: this.selectedFile,
        fileName: this.fileName || this.selectedFile.name
      });
      this.reset();
    }
  }

  reset(): void {
    this.fileName = '';
    this.selectedFile = null;
    this.isSubmitted = false;
    if (this.fileInputRef && this.fileInputRef.nativeElement) {
      this.fileInputRef.nativeElement.value = '';
    }
  }

}
